import React from "react";
import CourseCategories from "../../components/content/course-note/course-categories/CourseCategories";

export default class CourseNoteCategoriesRoute extends React.PureComponent<{
    courseId?: string | null;
}> {
    render(): React.ReactNode {
        const { courseId } = this.props;

        if (courseId == null) {
            return null;
        }

        return <CourseCategories courseId={Number(courseId)} />;
    }
}
